/* eslint-disable @typescript-eslint/naming-convention */

export const BASE_COLORS = {
  red10: '#7f1d1d',
  red20: '#991b1b',
  red30: '#b91c1c',
  red40: '#dc2626',
  red50: '#ef4444',
  red60: '#f87171',
  red70: '#fca5a5',
  red80: '#fecaca',
  red90: '#fee2e2',
  red97: '#fef2f2',
  red05: '#450a0a',
  orange10: '#7e2a0c',
  orange20: '#9f2d00',
  orange30: '#ca3500',
  orange40: '#f54900',
  orange50: '#ff6900',
  orange60: '#ff8904',
  orange70: '#ffb86a',
  orange80: '#ffd6a7',
  orange90: '#ffedd4',
  orange97: '#fff7ed',
  orange05: '#441306',
  'orange50-50': 'rgba(255, 105, 0, 0.5)',
  yellow10: '#713f12',
  yellow20: '#854d0e',
  yellow30: '#a16207',
  yellow40: '#ca8a04',
  yellow50: '#eab308',
  yellow60: '#facc15',
  yellow70: '#fde047',
  yellow80: '#fef08a',
  yellow90: '#fef9c3',
  yellow97: '#fefce8',
  yellow05: '#422006',
  green10: '#14532d',
  green20: '#166534',
  green30: '#15803d',
  green40: '#16a34a',
  green50: '#22c55e',
  green60: '#4ade80',
  green70: '#86efac',
  green80: '#bbf7d0',
  green90: '#dcfce7',
  green97: '#f0fdf4',
  green05: '#052e16',
  teal10: '#0b4f4a',
  teal20: '#005f5a',
  teal30: '#00786f',
  teal40: '#009689',
  teal50: '#00bba7',
  teal60: '#00d5be',
  teal70: '#46ecd5',
  teal80: '#96f7e4',
  teal90: '#cbfbf1',
  teal97: '#f0fdfa',
  teal05: '#022f2e',
  blue10: '#1e3a8a',
  blue20: '#1e40af',
  blue30: '#1d4ed8',
  blue40: '#2563eb',
  blue50: '#2675de',
  blue60: '#4592ee',
  blue70: '#7caeec',
  blue80: '#bfdbfe',
  blue90: '#cce6fc',
  blue97: '#f2faff',
  blue05: '#172554',
  emerald10: '#064e3b',
  emerald20: '#065f46',
  emerald30: '#047857',
  emerald40: '#059669',
  emerald50: '#10b981',
  emerald60: '#34d399',
  emerald70: '#6ee7b7',
  emerald80: '#a7f3d0',
  emerald90: '#d1fae5',
  emerald97: '#ecfdf5',
  emerald05: '#022c22',
  purple10: '#581c87',
  purple20: '#6b21a8',
  purple30: '#7e22ce',
  purple40: '#9333ea',
  purple50: '#a855f7',
  purple60: '#c084fc',
  purple70: '#d8b4fe',
  purple80: '#e9d5ff',
  purple90: '#f3e8ff',
  purple97: '#faf5ff',
  purple05: '#3b0764',
  indigo10: '#312e81',
  indigo20: '#3730a3',
  indigo30: '#4338ca',
  indigo40: '#4f46e5',
  indigo50: '#6366f1',
  indigo60: '#818cf8',
  indigo70: '#a5b4fc',
  indigo80: '#c7d2fe',
  indigo90: '#e0e7ff',
  indigo97: '#eef2ff',
  indigo05: '#1e1b4b',
  neutral10: '#161c22',
  neutral13: '#1b2128',
  neutral15: '#20262e',
  neutral20: '#29313a',
  neutral25: '#333c46',
  neutral30: '#3e4853',
  neutral35: '#48545f',
  neutral40: '#54606c',
  neutral45: '#606c79',
  neutral50: '#6c7886',
  neutral55: '#788593',
  neutral60: '#8592a0',
  neutral65: '#939fad',
  neutral70: '#a1acba',
  neutral75: '#b1bac4',
  neutral80: '#c1c7cf',
  neutral85: '#cdd2d8',
  neutral87: '#d8dce0',
  neutral90: '#e0e3e6',
  neutral93: '#e8eaec',
  neutral95: '#f0f1f2',
  neutral97: '#f7f8f9',
  neutral100: '#ffffff',
  neutral07: '#12171c',
  neutral05: '#0d1116',
  neutral00: '#000000',
  stone10: '#161616',
  stone13: '#1f1f1f',
  stone15: '#292929',
  stone20: '#333333',
  stone25: '#3d3d3d',
  stone30: '#484848',
  stone35: '#525252',
  stone40: '#5d5d5d',
  stone45: '#696968',
  stone50: '#7b7a79',
  stone55: '#878684',
  stone60: '#999896',
  stone65: '#a6a4a0',
  stone70: '#b3b1ac',
  stone75: '#c0bdb6',
  stone80: '#cecac1',
  stone85: '#dbd7cd',
  stone87: '#e5e1d6',
  stone90: '#efebdf',
  stone93: '#f5f1e8',
  stone95: '#f8f5ed',
  stone97: '#fbf9f3',
  stone99: '#fdfcf8',
  stone100: '#ffffff',
  stone07: '#010101',
  stone05: '#000000',
  stone00: '#000000',
  'stone97-00': 'rgba(251, 249, 243, 0)',
  'stone97-85': 'rgba(251, 249, 243, 0.85)',
  'stone20-00': 'rgba(51, 51, 51, 0)',
  'stone10-00': 'rgba(22, 22, 22, 0)',
  'stone10-85': 'rgba(22, 22, 22, 0.85)',
  'stone20-85': 'rgba(51, 51, 51, 0.85)',
  'stone95-00': 'rgba(248, 245, 237, 0)',
  'stone25-00': 'rgba(61, 61, 61, 0)',
  'stone99-85': 'rgba(253, 252, 248, 0.85)',
  'stone90-85': 'rgba(239, 235, 223, 0.85)',
  'stone65-50': 'rgba(166, 164, 160, 0.5)',
  'stone65-85': 'rgba(166, 164, 160, 0.85)',
  'stone50-50': 'rgba(123, 122, 121, 0.5)',
  white: '#FFFFFF',
  white60: 'rgba(255,255,255,0.6)',
  black: '#000000',
  blackish: '#252525',
  black3: 'rgba(23,30,39,0.8)',
  danger: '#e80000',
  emeraldGreen: '#32936F',
  emerald500: '#00BBA7',
  lightGrey: '#F1F1F1F1',
  grey: '#A6A6A6',
  darkGrey: '#898A8C',
  veryDarkGrey: '#3E3E40',
  darkPrimaryDarker: '#090f13',
  darkPrimary: '#111B24',
  darkPrimaryLight: '#1B2834',
  darkPrimaryLighter: '#242D39',
  darkPrimaryLightest: '#2E3745',
  borderFocus: '#438FFF',
  stone300: '#D6D3D1',
  stone400: '#A6A09B',
  stone500: '#79716B',
  stone600: '#57534D',
  stone700: '#44403B',
  stone800: '#292524',
  stone900: '#1C1917',
  stone950: '#0C0A09',
  sepia50: '#FEFDFB',
  sepia100: '#FBF9F4',
  sepia300: '#EDEAE3',
  sepia400: '#E1DED8',
  neutralWarm05: '#180f09',
  neutralWarm10: '#251912',
  neutralWarm15: '#30231a',
  neutralWarm20: '#3c2d23',
  neutralWarm25: '#48382c',
  neutralWarm30: '#544335',
  neutralWarm35: '#614f3f',
  neutralWarm40: '#6d5b4a',
  neutralWarm45: '#7a6755',
  neutralWarm50: '#867460',
  neutralWarm55: '#93816b',
  neutralWarm60: '#a08e77',
  neutralWarm65: '#ad9b84',
  neutralWarm70: '#baa990',
  neutralWarm75: '#c7b79d',
  neutralWarm80: '#d4c5ab',
  neutralWarm85: '#e1d3b9',
  neutralWarm90: '#eae2d2',
  neutralWarm95: '#f4f0e9',
  neutralWarm97: '#faf9f6',
  neutralWarm100: '#FFFFFF',
  yellow300: '#FDE047',
  orange100: '#FF7A00',
  orange400: '#FF8904',
  orange450: '#FB9100',
  orange600: '#F54900',
  cyan100: '#00B2F6',
  green50bw: '#318835',
  white50Opacity: 'rgba(255,255,255,0.5)',
  sepiaBackground: '#FBF0D9',
  sepiaText: '#5F4B32',
  teal01: '#011818',
  teal700: '#00786F',
  sky400: '#009DFF',
  sky500: '#008AF4',
};
export const U_ALPHA_LIGHT = {
  uAlpha100: 'rgba(62, 72, 83, 0.03)',
  uAlpha200: 'rgba(104,121,141,0.1)',
  uAlpha300: 'rgba(40, 49, 59, 0.09)',
  uAlpha400: 'rgba(40, 49, 59, 0.12)',
  uAlpha500: 'rgba(40, 49, 59, 0.15)',
  uAlphaRed200: 'rgba(219,60,47,0.06)',
  uAlphaBlue100: 'rgba(45, 117, 229, 0.05)',
  uAlphaBlue200: 'rgba(26,89,200,0.06)',
  uAlphaBlue300: 'rgba(24, 90, 189, 0.09)',
  uAlphaNeutral200: 'rgba(110, 120, 130, 0.1)',
  uAlphaStone80: 'rgba(123, 122, 121, 0.10)',
  uAlphaOrange70: 'rgba(255, 105, 0, 0.15)',
  uAlphaOrange80: 'rgba(255, 73, 0, 0.10)',
  uAlphaEmerald70: 'rgba(16, 185, 129, 0.15)',
};
export const U_ALPHA_DARK = {
  uAlpha100: 'rgba(92, 105, 119, 0.2)',
  uAlpha200: 'rgba(104,121,141,0.23)',
  uAlpha300: 'rgba(92, 105, 119, 0.34)',
  uAlpha400: 'rgba(92, 105, 119, 0.42)',
  uAlpha500: 'rgba(92, 105, 119, 0.52)',
  uAlpha600: 'rgba(92, 105, 119, 0.62)',
  uAlphaRed200: 'rgba(219,60,47,0.26)',
  uAlphaBlue100: 'rgba(45, 117, 229, 0.18)',
  uAlphaBlue200: 'rgba(45,117,229,0.15)',
  uAlphaBlue300: 'rgba(24, 90, 189, 0.09)',
  uAlphaNeutral200: 'rgba(110, 120, 130, 0.2)',
  uAlphaStone80: 'rgba(123, 122, 121, 0.20)',
  uAlphaOrange70: 'rgba(255, 105, 0, 0.32)',
  uAlphaOrange80: 'rgba(255, 73, 0, 0.23)',
  uAlphaEmerald70: 'rgba(16, 185, 129, 0.32)',
};
export const BOOKWISE_U_ALPHA = {
  uAlpha100: 'rgba(87,83,77,0.05)',
  uAlpha200: 'rgba(87,83,77,0.1)',
  uAlpha300: 'rgba(87,83,77,0.2)',
};
export const BOOKWISE_U_ALPHA_DARK = {
  uAlpha100: 'rgba(92, 105, 119, 0.2)',
  uAlpha200: 'rgba(104,121,141,0.23)',
  uAlpha300: 'rgba(92, 105, 119, 0.34)',
};
export const SHADOWS = {
  shadow100: {
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.15,
    shadowRadius: 1.0,
    elevation: 1,
  },
  shadow200: {
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.17,
    shadowRadius: 2.54,
    elevation: 3,
  },
  shadow300: {
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.2,
    shadowRadius: 5.62,
    elevation: 8,
  },
  shadow400: {
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 0.23,
    shadowRadius: 12.81,
    elevation: 16,
  },
};
export const highlightColorLight = 'rgba(255, 243, 134, 0.5)';
export const highlightColorDark = '#0b5173';
